import React from 'react';
import {connect} from 'react-redux';
import { RIEInput } from 'riek';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
const log = new Logger('AVA_RIEINPUT', LOG_LEVELS.ERROR);


export class AvaRIEInput extends React.Component {

  render() {
    // If disabled, just render the value as plain text
    if (this.props.disabled) {
      return (
        <span className={this.props.className} style={{ cursor: 'not-allowed', opacity: 0.6 }}>
          {this.props.value || ""}
        </span>
      );
    }

    return (
      <span>
        <RIEInput
          propName={this.props.propName}
          value={this.props.value || ""}
          change={this.props.change}
          classEditing={this.props.classEditing}
          className={this.props.className}
        />
      </span>
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {};
}


AvaRIEInput.defaultProps = {
  propName:     '',
  value:        '',
  change:       () => {},
  classEditing: 'editing',
  className:    'editable',
  disabled:     false
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(AvaRIEInput);